import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=f039071a&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=ts"
export * from "./PriceTable.vue?vue&type=script&lang=ts"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=f039071a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039071a",
  null
  
)

export default component.exports